<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                <translate>Adresse bearbeiten</translate>
            </modal-header>
            <modal-content>

                <form-input id="company" label="Firma" name="company" v-model="form.company"
                            :error="form.errors.company"/>

                <form-input id="name" label="Name" name="name" v-model="form.name"
                            :error="form.errors.name"/>

                <form-input id="street_additional" label="Abteilung" name="street_additional"
                            v-model="form.street_additional"
                            :error="form.errors.street_additional"/>

                <form-group>
                    <form-input id="street" label="Straße" name="street" v-model="form.street"
                                :error="form.errors.street" class="two-three"/>
                    <form-input id="street_no" label="Nummer" name="street_no" v-model="form.street_no"
                                :error="form.errors.street_no" class="one-three"/>
                </form-group>

                <form-group>
                    <form-input id="zip" label="PLZ" name="zip" v-model="form.zip"
                                :error="form.errors.zip" class="one-three"/>
                    <form-input id="city" label="Ort" name="city" v-model="form.city"
                                :error="form.errors.city" class="two-three"/>
                </form-group>

                <form-select id="client_country_id" label="Land" name="client_country_id"
                             v-model="form.client_country_id" :error="form.errors.client_country_id"
                             :options="clientCountryOptions"/>

                <form-input id="phone" label="Telefon" name="phone" v-model="form.phone"
                            :error="form.errors.phone"/>

                <form-input id="mobile" label="Mobil" name="mobile" v-model="form.mobile"
                            :error="form.errors.mobile"/>

                <form-input id="fax" label="Fax" name="fax" v-model="form.fax"
                            :error="form.errors.fax"/>
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormGroup from '@partfactory/Shared/Form/FormGroup';

export default {
    name: 'AskForQuoteAddress',
    components: {
        FormGroup,
        FormSelect, FormInput, FormButton, ModalActions, ModalContent, ModalHeader, Modal
    },
    emit: ['closeDialog'],
    props: {
        askForQuoteAddress: Object,
        clientCountries: Object,
    },
    data() {
        const form = useForm({
            default_address: this.askForQuoteAddress?.default_address,
            company: this.askForQuoteAddress?.company,
            name: this.askForQuoteAddress?.name,
            street: this.askForQuoteAddress?.street,
            street_no: this.askForQuoteAddress?.street_no,
            street_additional: this.askForQuoteAddress?.street_additional,
            zip: this.askForQuoteAddress?.zip,
            city: this.askForQuoteAddress?.city,
            client_country_id: this.askForQuoteAddress?.client_country_id,
            phone: this.askForQuoteAddress?.phone,
            mobile: this.askForQuoteAddress?.mobile,
            fax: this.askForQuoteAddress?.fax,
        });

        return {form};
    },
    computed: {
        clientCountryOptions() {
            return this.clientCountries;
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .patch(this.$$route('ask-for-quote.order-information.ask-for-quote-address.patch', {
                    'askForQuote': this.askForQuoteAddress.ask_for_quote_id,
                    'askForQuoteAddress': this.askForQuoteAddress.id,
                }), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        },
    },
};
</script>
